import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { MemberService } from '../../_service/member.service';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { PageEvent,MatPaginator } from '@angular/material/paginator';
import { MiscService } from '../../_service/misc.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { formatDate } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-member-leads',
  templateUrl: './member-leads.component.html',
  styleUrls: ['./member-leads.component.css']
})
export class MemberLeadsComponent implements OnInit {

  perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;
  pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;sc3Url:string='';
  search:string;userId:string;memberList=[];circles=[];circle:string;submitted:boolean=false;alltreatments=[];treatments_copy=[];treatCategory=[];lead_sources=[];category_filter=[];lab_category=[];treatment='';lead_category_filter='';lead_source='';lab_category_filter='';start_date:string='';end_date:string='';

  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('csvUploadTransactionData', {static: false}) csvUploadTransactionData: ElementRef;

  constructor(private leadapi:LeadsService,private memberapi:MemberService,private sharedapi:SharedService,private dialog:MatDialog,private activatedRoute: ActivatedRoute,private router: Router,public miscapi:MiscService) { }

  ngOnInit(): void {
    this.myrole = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');
    this.sc3Url= localStorage.getItem('s3url');
    this.getcircle(); 
    this.getTreatment(); 
    this.getTreatmentCategory(); 
    this.getLeadSources(); 
    this.getLabtestCategory();
    
  }

  ngAfterViewInit() {
    this.loadmembersLeads(0,this.perpage);
  }

  setSearchValue(type)
  {
    if(type=='treatment'){
      $("#treatmentSearch").val('');
      $("#treatmentSearch").focus();
      this.alltreatments= this.treatments_copy;
    }
  }

  searchOnSelect(searchtText: string, type)
  {
    if (type == 'treatment') {
      this.alltreatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    }
  }

  async getcircle()
  {
      await this.leadapi.getcircles().subscribe((data:any) => {
          if(data.status)
          {
              this.circles = data.data;
          }else{
              this.circles = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getTreatment()
  {
      await this.leadapi.getTreatments().subscribe((data:any) => {
          if(data.status)
          {
              this.alltreatments = data.data;
              this.treatments_copy = this.alltreatments;
          }else{
              this.alltreatments = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getTreatmentCategory()
  {
      await this.miscapi.getTreat_Category().subscribe((data:any) => {
          if(data.status)
          {
              this.treatCategory = data.data;
          }else{
              this.treatCategory = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getLeadSources()
  {
    let uri = 'none';
    this.leadapi.getUpdatedLeadSources(uri).subscribe((data:any) => {
      if(data.status)
      {
          this.lead_sources = data.data;
      }else{
          this.lead_sources = [];
      }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async getLabtestCategory()
  {
    this.memberapi.getLabtestCategory().subscribe((data:any) => {
      if(data.status)
      {
          this.lab_category = data.data;
      }else{
          this.lab_category = [];
      }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  resetFilters()
  {
    this.search = ''; this.circle = ''; this.lead_category_filter = ''; this.treatment = ''; this.lead_source = ''; this.lab_category_filter = '';
    this.clearDate();
    this.loadmembersLeads(0,25);
  }

  async loadmembersLeads(pageIndex,perpage)
  {
      this.paginator.pageIndex = pageIndex; 
      this.paginatorBottom.pageIndex = pageIndex;
      this.pageIndex = pageIndex;
      let qString = 'search='+this.search+'&circle='+this.circle+'&treatment_filter='+this.treatment+'&lead_category_filter='+this.lead_category_filter+'&lead_source='+this.lead_source+'&lab_category_filter='+this.lab_category_filter+'&date_range='+this.start_date+'-'+this.end_date;
      this.loading = true;this.loaded = false;
      this.memberList = [];
      await this.memberapi.loadMemberLeadData(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
          this.length = data.totaldata;
          this.loading = false;
          this.loaded = true;
          if(data.status)
          {
            this.memberList = data.data;
          } 
          else 
          {
            this.memberList = [];
          }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadmembersLeads(event.pageIndex,event.pageSize);
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
      }
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
  }

  exportMemberLeadData()
  {
    if(this.memberList.length>0)
    {
      let data = [];
      let titles = ['Name','Source','Treatment','Treatment Catergory','Package','City Name','Circle Name','Test Catergory','Test Sub-Catergory','Date','Lead Type'];

      
      data.push(titles);
      for(let key in this.memberList)
      {
          let mem_type = '';
          if(this.memberList[key].lead_type==1){
            mem_type = 'Surgery Lead';
          }else if(this.memberList[key].lead_type==2){
            mem_type = 'Lab Lead';
          }else if(this.memberList[key].lead_type==3){
            mem_type = 'Retail Lead';
          }else if(this.memberList[key].lead_type==4){
            mem_type = 'Corporate Lead';
          }

          let created_at ='';
          if(this.memberList[key].created_at){
            created_at = formatDate(this.memberList[key].created_at*1000, 'dd/MM/yyyy', 'en-US');
          }

 

          let exdata = [
            this.memberList[key].lead_name,
            //this.memberList[key].mobile,
            this.memberList[key].source_name,
            this.memberList[key].treatment_name,
            this.memberList[key].catergory_name,
            this.memberList[key].plan_name,
            this.memberList[key].city_name,
            this.memberList[key].circle_name,
            this.memberList[key].category_test_name,
            this.memberList[key].test_name,
            created_at,
            mem_type
          ];
          


          data.push(exdata);
      }


      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
      XLSX.writeFile(wb, 'member_lead_'+utc+'.xlsx');
    }else{
        this.sharedapi.presentToast('No Member lead found.');
    }
  }

}